import DashboardView from "../../features/dashboard/DashboardView";

const DashboardPage = () => <DashboardView />;

export default DashboardPage;
